import * as Yup from 'yup';

export const permissionSchema = Yup.object().shape({

    permissionId: Yup.number().min(1,"Please enter valid number").required("Please enter a permission id"),
    name: Yup.string().required("Please enter a name"),
    
})
